import { Paginated, Sortable } from "@ac-expo/api-types";
import { FilterStructureDocumentType } from "../queries";

export const structureDocumentsQueryKeys = {
  all: ["structureDocuments"] as const,
  lists: () => [...structureDocumentsQueryKeys.all, "lists"] as const,
  list: (
    structureId: string,
    filters?: Paginated<Sortable<FilterStructureDocumentType>>
  ) =>
    filters
      ? [...structureDocumentsQueryKeys.lists(), structureId, filters]
      : ([...structureDocumentsQueryKeys.lists(), structureId] as const),
  infiniteList: (
    structureId: string,
    filters?: Sortable<FilterStructureDocumentType>
  ) =>
    filters
      ? ([
          ...structureDocumentsQueryKeys.list(structureId),
          "infinite",
          filters,
        ] as const)
      : ([
          ...structureDocumentsQueryKeys.list(structureId),
          "infinite",
        ] as const),
  details: () => [...structureDocumentsQueryKeys.all, "details"] as const,
  detail: (documentId: string) =>
    [...structureDocumentsQueryKeys.details(), documentId] as const,
};
